export default __webpack_public_path__ + "static/media/1100.22e1bf2d.png";